import { type SelectOption } from '@shared/utils/types/select-option';

export const getOptionByValue = <T>(options: Array<SelectOption<T>>, value: null | T | undefined) =>
  options.find((option) => option?.value === value) ?? null;
